import router from "@/router";
import _ from "lodash";
import emUtils from "@/utils/emUtils";

/**
 * 判断当前的对象是否是继承了 common/EntityModule.js/newEntityStoreHelper()
 * @param {String} entity 当前的实体名称
 */
function isInstanceOfCommonEntity(context, entity) {
    // return entityList.includes(entity)
    return context.rootGetters[entity + '/buildByEntityStoreHelper'];
}

function getSaveUrl(api, entityApi, context, entity, entityState, entityAux) {
    //如果传入了api，就直接等于api
    if (api) {
        return api
    }
    //否则，如果指定了entityApi，就用entity的url来拼接entityApi
    else if (entityApi) {
        return `${context.rootState[entity].baseModuleUrl}/${entity}/${entityApi}`
    }
    //否则，就使用默认
    else {
        if (entityAux.id) {
            //如果entityState不等于entity，就默认调用selective接口，部分保存
            if (entityState !== "entity") {
                return `${context.rootState[entity].baseModuleUrl}/${entity}/selective`
            } else {
                return `${context.rootState[entity].baseModuleUrl}/${entity}/edit`
            }
        } else {
            //id为空就必须走新增
            return `${context.rootState[entity].baseModuleUrl}/${entity}`
        }
    }
}

const state = {};
const getters = {};
const mutations = {};
const actions = {
    //这里代码太乱了，命名规则不统一。。。 先这样吧 难搞难搞
    //todo：这里很可能有各种bug
    emBaseClearFilter(context, {entity, filterState = 'filter', loadState = 'rows'} = {}) {
        if (entity && isInstanceOfCommonEntity(context, entity)) {
            let loadStateSuffix = loadState === "rows" ? "" : emUtils.toCapFirst(loadState)
            context.commit(`${entity}/setShowNoResultAlert${loadStateSuffix}`, false, {root: true});
            context.commit(`${entity}/setCheckedItems${loadStateSuffix}`, [], {root: true});
            context.commit(`${entity}/setClear${emUtils.toCapFirst(filterState)}`, undefined, {root: true});
            context.commit(`${entity}/clearFixedFilter`, undefined, {root: true});
            //清空查询记录
            context.commit(`${entity}/set${emUtils.toCapFirst(loadState)}`, [], {root: true});
        }
    },
    emBaseQueryPrepare(context, {entity, filterState = "filter", loadState = "rows"} = {}) {
        let filterStateSuffix = filterState === "filter" ? "" : emUtils.toCapFirst(filterState)
        let loadStateSuffix = loadState === "rows" ? "" : emUtils.toCapFirst(loadState)
        context.commit(`${entity}/setCurrentPage`, 1, {root: true});
        context.commit(`${entity}/setCheckChangesOnLoad`, true, {root: true});
        context.commit(`${entity}/setCheckedItems${loadStateSuffix}`, [], {root: true});
        context.commit(`${entity}/setCrudState`, 'list', {root: true});
        //add on 2019-10-9 by yujiabei
        //暂时先以这种方式阻止一次编辑多行，因为每次刷新后，现有的编辑行就失效了。所以干脆清除掉。
        context.commit(`${entity}/clearEditingRows${loadStateSuffix}`, {}, {root: true});
    },
    emBaseLoadState(context, {response, entity, loadState = "rows"} = {}, withPagination = true) {
        let loadStateSuffix = loadState === "rows" ? "" : emUtils.toCapFirst(loadState)
        if (response.data && response.data.list && response.data.list.length > 0) {
            context.commit(`${entity}/set${emUtils.toCapFirst(loadState)}`, response.data.list, {root: true});
            withPagination && context.commit(`${entity}/setPagination`, response.data.pagination, {root: true});
            if (loadState === "rows") {
                //暂时不显示这个提示了，怪烦的 - 2020-10-11
                // context.dispatch(`${entity}/showItemLimitationAlert`, entity, {root: true});
                context.dispatch(`${entity}/afterLoadRowsTrigger`, response.data.list, {root: true})
                context.commit(`${entity}/setShowNoResultAlert${loadStateSuffix}`, false, {root: true});
            }
        } else {
            if (loadState === "rows") {
                context.commit(`${entity}/setShowNoResultAlert${loadStateSuffix}`, true, {root: true});
            }
            //如果为空，并且是自定义的loadState，就把loadState清空一下，非自定义的，已经有统一的清空动作了
            else {
                context.commit(`${entity}/set${emUtils.toCapFirst(loadState)}`, [], {root: true});
            }
        }
    },
    emBaseQueryByFilter(context, {
        entity,
        filterState = 'filter'
        ,
        loadState = 'rows',
        queryApi = 'findByFilter',
        queryPrepareMutation,
        withPagination = true,
        ignoreMaxTableItemLimit = false
    } = {}) {
        if (entity && isInstanceOfCommonEntity(context, entity)) {
            return context.dispatch('emBase/emBaseQueryPrepare', {
                entity,
                filterState,
                loadState,
                withPagination
            }, {root: true})
                .then(r => {
                    //如果传入了queryPrepareMutation，就执行
                    if (queryPrepareMutation)
                        context.commit(`${entity}/${queryPrepareMutation}`, {root: true})
                    return context.dispatch('emBaseQueryByFilterSearch', {
                        entity,
                        filterState,
                        queryApi,
                        loadState,
                        ignoreMaxTableItemLimit,
                        withPagination
                    })
                })
        }
    },
    emBaseQueryByFilterSearch(context, {
        entity, filterState = 'filter', loadState = 'rows'
        , queryApi = 'findByFilter', withPagination = true, ignoreMaxTableItemLimit = false
    } = {}) {

        context.commit(entity + "/setIgnoreMaxTableItemLimit", ignoreMaxTableItemLimit, {root: true});
        //支持自定义后端对应的实体类，未定义就取entity，调后端接口时会用到
        let backendEntity = context.rootState[entity].backendEntity ? context.rootState[entity].backendEntity : entity

        return new Promise((resolve, reject) => {
            // cloning filter to discard empty fields

            // filter is defined in each entity
            let cloneFilter = emUtils.getCloneFilter({context, entity, filterState, withPagination})

            context.dispatch("api/post", {
                url: `${context.rootState[entity].baseModuleUrl}/${backendEntity}/${queryApi}`,
                data: cloneFilter
            }, {root: true})
                .then(response => {
                        //setting the values
                        if (isInstanceOfCommonEntity(context, entity)) {
                            // if (loadState === 'rows')
                            context.dispatch('emBase/emBaseLoadState', {
                                entity,
                                response,
                                loadState,
                                withPagination
                            }, {root: true})
                            //如果使用了自定义loadState，需要配套提供自定义的loadStateForLoadStateAction
                            // else {
                            //     if (response.data && response.data.list) {
                            //         context.dispatch(`${entity}/load${loadState.replace(loadState[0], loadState[0].toUpperCase())}`, response.data.list, {root: true})
                            //     }
                            // }
                        }
                        resolve(response);
                    }
                )
                .catch((err) => reject(err))
            // .catch(() => {
            //     if (filterState === 'fixedFilter')
            //         context.commit("base/setShowLoadingModal", false, {root: true});
            //     // 至于要不要提供查询失败的action，先不用了吧。api已经对catch做统一处理了，回头有需要再说
            //     // else
            //     // context.dispatch(`${entity}/queryRejectFor` + filterState.replace(filterState[0], filterState[0].toUpperCase(), {root: true}))
            // });
        })
    },

    /**
     *
     * @param context
     * @param entity
     * @param entityState
     * @param api 指定保存的api，优先级最高
     * @param entityApi 指定entityUrl后的api，优先级低于上面的api
     * @param returnPath 指定返回路径，url全路径
     * @param autoReturn 是否自动返回list，当未指定returnPath时，才会判断这里
     */
    emBaseSave(context, {entity, entityState = 'entity', api, entityApi, returnPath, autoReturnDisable = false}) {
        const entityAux = context.rootState[entity][entityState];

        //removing empty fields
        for (const key in entityAux) {
            if (entityAux.hasOwnProperty(key) && (entityAux[key] === "")) delete entityAux[key]
        }

        let strCrud = "Save";
        if (context.rootState[entity].crudState === "edit")
            strCrud = "Edit"

        //TODO remove hardcoded for Integration Message Config
        if (entityAux.messageDefinition) {
            let id = entityAux.messageDefinition
            delete entityAux.messageDefinition
            entityAux.messageDefinition = {
                id: id
            }
        }

        if (entityAux.messageDataConversions) {
            entityAux.messageDataConversions.forEach(element => {
                delete element.rowState;
            });
        }

        // 2020-12-18 取消掉了saveForm参数，因为单个saveForm已经支持了多套前端form，结合调用后端的selective接口，就可以实现需求了，没必要搞的更复杂了
        //支持自定义后端对应的实体类，未定义就取entity，调后端接口时会用到 --2020-10-5 yujiabei
        // let backendEntity = context.rootState[entity].backendEntity ? context.rootState[entity].backendEntity : entity
        // let backendEntity = saveForm ? saveForm : entity

        //拼接url
        let url = getSaveUrl(api, entityApi, context, entity, entityState, entityAux);

        return context.dispatch("api/put", {
            url: url,
            entity: entityAux,
            module: entity
        }, {
            root: true
        })
            .then(function (entityReturn) {
                // set needToRefresh
                context.commit(`${entity}/setNeedToRefresh`, true, {
                    root: true
                })
                // doing search again
                context.dispatch("base/showSuccess", {
                    userAlertSuccessStr: strCrud + " success {id=" + entityReturn.id + "}",
                    dismissCountDown: 5,
                    userAlertSuccessVisible: false,
                }, {
                    root: true
                }).then(function () { // doing search again
                    //获取returnUrl，先以参数为准，再以vuex中的editReturnUrl为准，都没有就用默认的
                    let returnUrl = returnPath ? returnPath : context.rootState[entity].editReturnUrl
                    let returnPathType = context.rootState[entity].editReturnPathType
                    //如果有，就返回到returnUrl
                    if (returnUrl && returnUrl !== "") {
                        router.push({
                            path: returnUrl,
                            query: {
                                pathType: returnPathType ? returnPathType : 'list'
                            }
                        });
                        //returnUrl是一次性的，使用过后要清除掉
                        context.commit(entity + "/setEditReturnUrl", "", {
                            root: true
                        })
                        context.commit(entity + "/setEditReturnPathType", "", {
                            root: true
                        })
                    }
                    //没有returnUrl,判断自动返回是否为真，如果是就返回默认的List
                    else if (!autoReturnDisable) {
                        return context.dispatch("base/MMFbackToList", entity, {
                            root: true
                        })
                        //进入页面就自动刷新了，所以不用这里了
                        // .then(function () {
                        //     context.dispatch("base/MMFLoadRows", entity, {
                        //         root: true
                        //     });
                        // });
                    }
                })
            });
    },

    emBaseCustomSave(context, {
        entity,
        backToList,
        strCrud = 'Save',
        entityAux,
        entityState = 'entity',
        api,
        entityApi,
        returnPath,
        autoReturnDisable = false,
        userAlertSuccessStr = ''
    }) {

        //removing empty fields
        for (const key in entityAux) {
            if (entityAux.hasOwnProperty(key) && (entityAux[key] === "")) delete entityAux[key]
        }

        //TODO remove hardcoded for Integration Message Config
        if (entityAux.messageDefinition) {
            let id = entityAux.messageDefinition
            delete entityAux.messageDefinition
            entityAux.messageDefinition = {
                id: id
            }
        }

        if (entityAux.messageDataConversions) {
            entityAux.messageDataConversions.forEach(element => {
                delete element.rowState;
            });
        }

        // 2020-12-18 取消掉了saveForm参数，因为单个saveForm已经支持了多套前端form，结合调用后端的selective接口，就可以实现需求了，没必要搞的更复杂了
        //支持自定义后端对应的实体类，未定义就取entity，调后端接口时会用到 --2020-10-5 yujiabei
        // let backendEntity = context.rootState[entity].backendEntity ? context.rootState[entity].backendEntity : entity
        // let backendEntity = saveForm ? saveForm : entity

        //拼接url
        let url = getSaveUrl(api, entityApi, context, entity, entityState, entityAux);

        return context.dispatch("api/put", {
            url: url,
            entity: entityAux,
            module: entity
        }, {
            root: true
        })
            .then(function (entityReturn) {
                // set needToRefresh
                context.commit(`${entity}/setNeedToRefresh`, true, {
                    root: true
                })

                if (!userAlertSuccessStr) userAlertSuccessStr = strCrud + " success {id=" + entityReturn.id + "}";
                // doing search again
                context.dispatch("base/showSuccess", {
                    userAlertSuccessStr: userAlertSuccessStr,
                    dismissCountDown: 5,
                    userAlertSuccessVisible: false,
                }, {
                    root: true
                }).then(function () { // doing search again
                    //获取returnUrl，先以参数为准，再以vuex中的editReturnUrl为准，都没有就用默认的
                    let returnUrl = returnPath ? returnPath : context.rootState[entity].editReturnUrl
                    let returnPathType = context.rootState[entity].editReturnPathType
                    //如果有，就返回到returnUrl
                    if (returnUrl && returnUrl !== "") {
                        router.push({
                            path: returnUrl,
                            query: {
                                pathType: returnPathType ? returnPathType : 'list'
                            }
                        });
                        //returnUrl是一次性的，使用过后要清除掉
                        context.commit(entity + "/setEditReturnUrl", "", {
                            root: true
                        })
                        context.commit(entity + "/setEditReturnPathType", "", {
                            root: true
                        })
                    }
                    //没有returnUrl,判断自动返回是否为真，如果是就返回默认的List
                    else if (!autoReturnDisable) {
                        return context.dispatch("base/MMFbackToList", backToList ? backToList : entity, {
                            root: true
                        })
                        //进入页面就自动刷新了，所以不用这里了
                        // .then(function () {
                        //     context.dispatch("base/MMFLoadRows", entity, {
                        //         root: true
                        //     });
                        // });
                    }
                })
            });
    },

    //todo : 和save一样，分为api和entityApi
    emBaseSaveInline(context, {entity, entityState = 'entity', entityApi, api}) {
        const entityAux = context.rootState[entity][entityState];

        //removing empty fields
        for (const key in entityAux) {
            if (entityAux.hasOwnProperty(key) && (entityAux[key] === "")) delete entityAux[key]
        }

        let strCrud = "Save";
        if (context.rootState[entity].crudState === "edit")
            strCrud = "Edit"

        //拼接url
        let url = getSaveUrl(api, entityApi, context, entity, entityState, entityAux);

        context.dispatch("api/put", {
            url: url,
            entity: entityAux,
            module: entity
        }, {
            root: true
        })
            .then(function (entityReturn) {
                // doing search again
                // set needToRefresh
                context.commit(`${entity}/setNeedToRefresh`, true, {
                    root: true
                })
                context.dispatch("base/showSuccess", {
                    userAlertSuccessStr: strCrud + " success {id=" + entityReturn.id + "}",
                    dismissCountDown: 5,
                    userAlertSuccessVisible: false,
                }, {root: true})
            })
    },

    emBaseNew(context, {entity, entityState = 'entity', fromPathType}) {
        router.push({
            name: entity + 'Edit',
            query: {
                entityState: entityState,
                fromPathType: fromPathType
            }
        });
        context.commit(`${entity}/setNew${emUtils.toCapFirst(entityState)}`, {}, {
            root: true
        });
        context.commit(entity + "/" + "setCrudState", 'new', {
            root: true
        });
    },
    emBaseEdit(context, {entity, entityState = 'entity', fromPathType}) {
        const saveEntity = _.cloneDeep(context.rootState[entity][entityState]);

        context.commit(`${entity}/set${emUtils.toCapFirst(entityState)}`, saveEntity, {
            root: true
        });
        context.commit(entity + "/" + "setCrudState", 'edit', {
            root: true
        });
        router.push({
            name: entity + 'Edit',
            query: {
                entityState: entityState,
                fromPathType: fromPathType
            }
        });
    },
    emBaseSelectRow(context, {
        item,
        entity, entityState = 'entity', voState = "rows"

    }) {
        const checkedItemsVoState = voState === "rows" ? "checkedItems" : `checkedItems${emUtils.toCapFirst(voState)}`
        let items = context.rootState[entity][checkedItemsVoState].slice();
        let rows = context.rootState[entity][voState].slice();
        let indexA = items.indexOf(item.id);

        if (indexA > -1) { // desselecting
            items.splice(indexA, 1);
            // 备选项中的最后一个元素
            if (items.length) { // 如果还有备选元素
                const lastId = items[items.length - 1];
                item = rows.filter(r => r.id === lastId)[0] || {}
            } else {
                item = {}
            }
        } else { // selecting
            items.push(item.id)
        }
        context.commit(`${entity}/set${emUtils.toCapFirst(entityState)}`, item, {
            root: true
        });
        //add on 2020-12-18 为了做编辑撤销用
        context.commit(`${entity}/setEntityOrigin`, item, {
            root: true
        });
        context.commit(`${entity}/set${emUtils.toCapFirst(checkedItemsVoState)}`, items, {
            root: true
        });
    },
    //el table的行选中，只需维护entity和entityOrigin即可，上面方法中的items由el table的@selection-change事件来维护
    emBaseSelectRowForEl(context, {item, entity, entityState = 'entity'}) {
        context.commit(`${entity}/set${emUtils.toCapFirst(entityState)}`, item, {
            root: true
        });
        //add on 2020-12-18 为了做编辑撤销用
        context.commit(`${entity}/setEntityOrigin`, item, {
            root: true
        })
    },
    emBaseDelete(context, {entity, voState = 'rows'}) {
        let checkedItemsVoState = voState === 'rows' ? 'checkedItems' : `checkedItems${emUtils.toCapFirst(voState)}`
        let checkedItems = context.rootState[entity][checkedItemsVoState];
        if (checkedItems) {
            let params = 'id=' + checkedItems.join(',');

            // for (let i = 0; i < checkedItems.length; i++) {
            //     params += "&id=" + checkedItems[i];
            // }
            //支持自定义后端对应的实体类，未定义就取entity，调后端接口时会用到 --2020-10-5 yujiabei
            let backendEntity = context.rootState[entity].backendEntity ? context.rootState[entity].backendEntity : entity
            return context.dispatch("api/delete", {
                url: context.rootState[entity].baseModuleUrl + ("/" + backendEntity + "?" + params)
            }, {
                root: true
            })
                .then(function () {

                    // set needToRefresh
                    context.commit(`${entity}/setNeedToRefresh`, true, {
                        root: true
                    })
                    // doing search again
                    context.dispatch("base/showSuccess", {
                        userAlertSuccessStr: "Deleted!",
                        dismissCountDown: 5,
                        userAlertSuccessVisible: false,
                    }, {
                        root: true
                    })
                    //     .then(function () { // doing search again
                    //     context.dispatch("base/MMFLoadRows", entity, {
                    //         root: true
                    //     });
                    // })
                })
        }
    },
    emBaseDeleteInline(context, data) {
        //支持自定义后端对应的实体类，未定义就取entity，调后端接口时会用到 --2020-10-5 yujiabei
        let backendEntity = context.rootState[data.entity].backendEntity ? context.rootState[data.entity].backendEntity : data.entity
        return context.dispatch("api/delete", {
            url: context.rootState[data.entity].baseModuleUrl + ("/" + backendEntity + "?id=" + data.id)
        }, {
            root: true
        })
            .then(function () {
                // set needToRefresh
                context.commit(`${data.entity}/setNeedToRefresh`, true, {
                    root: true
                })
                // doing search again
                context.dispatch("base/showSuccess", {
                    userAlertSuccessStr: "Deleted!",
                    dismissCountDown: 5,
                    userAlertSuccessVisible: false,
                }, {
                    root: true
                })
                //     .then(function () { // doing search again
                //     context.dispatch("base/MMFLoadRows", data.entity, {
                //         root: true
                //     });
                // })
            });
    },
    EmExport(context, {
        entity,
        filterState = "filter",
        queryApi = "findByFilter",
        withPagination = true,
        exportParam,
        customFieldList = []
    }) {
        // filter is defined in each entity
        let cloneFilter = emUtils.getCloneFilter({context, entity, filterState, withPagination})
        const urlRep = process.env.VUE_APP_REPORT_API_URL + "report-service/mmf/report/dispatcher/";
        const url = urlRep + 'asynchronous';
        const data = {
            requestUrl: `${context.rootState[entity].baseModuleUrl}/${entity}/${queryApi}`,
            requestParam: Object.assign({}, cloneFilter, exportParam),
            customFieldList
        };
        context.dispatch("api/post", {
            url,
            data
        }, {
            root: true
        })
    },
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
